import Rest from '@/services/Rest';

/**
 * @typedef {CallbackService}
 */
export default class CallbackService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/callback'
}